import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const DowntimeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const emptyRecord = {
    downtime: null
  }
  const [data, setData] = useState<object|null>(_.get(props, "rowData.downtimedetail"));

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'downtimedetail', props.rowData)
  }

  const attrs = (field) => field_attrs('marketlease', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Downtime (Mos)</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="downtime" min={0} max={960} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default DowntimeBasic
